// Sub-Image Gallery
const gallery_main = document.querySelector('.gallery-main');
const gallery_nav = document.querySelector('.gallery-nav');

const initSlider = () => {
    // Temp to be replaced
    $galleryMain = $(gallery_main);
    $galleryNav = $(gallery_nav);
    $galleryMain.slick({
        infinite: false,
        arrows: false,
        fade: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    fade: false
                }
            }
        ]
    });

    $galleryNav
        .on('init', () =>  $('.slick-slide.slick-current').addClass('is-active'))
        ?.slick({
            focusOnSelect: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: false,
            arrows: true,
            appendArrows: '.gallery-arrows',
            nextArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="100" height="17" fill="#fff"><path d="M100 17H0v-4.07h44.86l2.85 2.9h45.4L77.67 0h5.62zM4.63 7.8H3.45L1.17 4v3.8H0V2h1.17l2.3 3.85V2h1.17zm5.24-2.5H7.62v1.55h2.64v.95h-3.8V2h3.8v1H7.62v1.37h2.25zm3.9-1.23l1.07-2h1.35L14.54 4.9l1.7 2.9h-1.36l-1.1-2-1.1 2h-1.36L13 4.9 11.37 2h1.35zM21.92 3h-1.75v4.8H19V3h-1.72V2h4.64z"/></svg>',
            prevArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="100" height="17" fill="#fff"><path d="M0 17h100v-4.07H55.14l-2.85 2.9H6.9L22.33 0H16.7zM58.3 5.78v2h-1.17V2h2.22a2.57 2.57 0 0 1 1.13.23 1.82 1.82 0 0 1 .75.68 1.92 1.92 0 0 1 .26 1 1.68 1.68 0 0 1-.58 1.35 2.36 2.36 0 0 1-1.58.49zm0-1h1a1 1 0 0 0 .69-.25.81.81 0 0 0 .24-.63 1 1 0 0 0-.24-.69 1 1 0 0 0-.68-.28h-1zm6.9.92h-.93v2.1H63.1V2h2.1a2.34 2.34 0 0 1 1.55.45 1.56 1.56 0 0 1 .55 1.29 1.82 1.82 0 0 1-.25 1 1.73 1.73 0 0 1-.77.62l1.24 2.37h-1.26zm-.93-1h.94a1 1 0 0 0 .69-.23.84.84 0 0 0 .24-.63.91.91 0 0 0-.23-.65 1 1 0 0 0-.7-.24h-.94zm8.17.6H70.2v1.55h2.64v.95H69V2h3.8v1h-2.6v1.37h2.25zm3.98 1.08L77.7 2H79l-2 5.8h-1.2L73.83 2h1.3zM81.6 7.8h-1.18V2h1.18zm6.56-2.7a3.5 3.5 0 0 1-.3 1.5 2.29 2.29 0 0 1-.85 1 2.34 2.34 0 0 1-3.25-.76l-.14-.26a3.51 3.51 0 0 1-.31-1.5V4.8a3.55 3.55 0 0 1 .3-1.51 2.31 2.31 0 0 1 .86-1 2.49 2.49 0 0 1 2.53 0 2.29 2.29 0 0 1 .85 1 3.51 3.51 0 0 1 .31 1.5zM87 4.8a2.48 2.48 0 0 0-.32-1.39 1 1 0 0 0-.91-.47 1 1 0 0 0-.91.47 2.35 2.35 0 0 0-.33 1.37v.32a2.47 2.47 0 0 0 .32 1.38 1.11 1.11 0 0 0 1.83 0A2.52 2.52 0 0 0 87 5.09zM94.1 2v3.8a2 2 0 0 1-.58 1.5 2.59 2.59 0 0 1-3.18 0 1.94 1.94 0 0 1-.6-1.47V2h1.18v3.85a1.14 1.14 0 0 0 .26.83 1.07 1.07 0 0 0 .74.26.94.94 0 0 0 1-.85V2zm4.72 4.3a.59.59 0 0 0-.23-.51 2.9 2.9 0 0 0-.84-.38 7.19 7.19 0 0 1-1-.4 1.59 1.59 0 0 1-1-1.43 1.46 1.46 0 0 1 .25-.84 1.65 1.65 0 0 1 .75-.58 2.71 2.71 0 0 1 1.1-.15 2.41 2.41 0 0 1 1.15.17 1.65 1.65 0 0 1 .73.63 1.71 1.71 0 0 1 .27.93h-1.17a.77.77 0 0 0-.25-.61 1 1 0 0 0-.69-.23 1.07 1.07 0 0 0-.67.19.56.56 0 0 0-.25.76.55.55 0 0 0 .25.25 3.21 3.21 0 0 0 .83.36 3.66 3.66 0 0 1 1.45.75 1.55 1.55 0 0 1 .5 1.08 1.41 1.41 0 0 1-.56 1.19 2.43 2.43 0 0 1-1.5.42 2.77 2.77 0 0 1-1.2-.24 1.85 1.85 0 0 1-.82-.65 1.68 1.68 0 0 1-.28-1h1.17c0 .64.38 1 1.13 1a1.09 1.09 0 0 0 .65-.18.56.56 0 0 0 .23-.53z"/></svg>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }
            ]
        });

    $galleryNav
        .on('click', '.slick-slide', function(event) {
            event.preventDefault();
            var goToSingleSlide = $(this).data('slick-index');
            $galleryMain?.slick('slickGoTo', goToSingleSlide);
        });

    $galleryMain.on('beforeChange', function(...e) {
        $galleryNav?.slick('slickGoTo', e.nextSlide);
        var currrentSlideElem = '.slick-slide[data-slick-index="' + e.nextSlide + '"]';
        $('.slick-slide.is-active').removeClass('is-active');
        $(currrentSlideElem).addClass('is-active');
    });
}

whenAvailable('slick', initSlider);

// Desktop-only effects
if (!isMobile && window.innerWidth >= 992) {
    let tilt_deg = 15;

    const titan_tilt = document.querySelector('#titan_tilt');
    const magnus_tilt = document.querySelector('#magnus_tilt'); // Split to reduce gyroscope angle X axis since this block is too tall
    
    const handleMouseLeave = e => {
        const _this = e.target

        if (_this.classList.contains('content-tt') || tilt_deg < 0) 
            tilt_deg *= -1;

        setTimeout(() => $(_this).css('transform', `perspective(1000px) rotateX(0deg) rotateY(${tilt_deg}deg) scale3d(1, 1, 1)`), 50)
    };

    whenAvailable('VanillaTilt', function() {
        VanillaTilt.init(titan_tilt);
        VanillaTilt.init(magnus_tilt, {
            gyroscopeMaxAngleX: 20
        });
    });

    titan_tilt.addEventListener('mouseleave', handleMouseLeave);
    magnus_tilt.addEventListener('mouseleave', handleMouseLeave);

    const toDataURL = url => new Promise(resolve => {
        const httpRequest = new XMLHttpRequest();
        
        httpRequest.onload = function() {
            var fileReader = new FileReader();
                fileReader.onloadend = function() {
                    resolve(fileReader.result)
                }
                fileReader.readAsDataURL(httpRequest.response);
        };

        httpRequest.open('GET', url);
        httpRequest.responseType = 'blob';
        httpRequest.send();
    });


    const gallery_items = document.querySelectorAll('.gallery-nav-item');
    const gallery_canvases = [];

    whenAvailable('Glitch', () => {
        gallery_items.forEach(el => {
            const src = el.getAttribute('src');
    
            toDataURL(src)
                .then(dataURL => {
                    // Prevent canvas from tainted by cross-origin data
                    el.setAttribute('src', dataURL);
                    el.nextElementSibling.setAttribute('src', dataURL);
                    
                    gallery_canvases.push(new Glitch(el));
                });
        });

        let resized = false

        window.addEventListener('resize', () => resized = true);
    
        window.addEventListener('mouseover', () => {
            if(!resized)
                return

            // Handle Glitch canvas size after resizing
            gallery_canvases.forEach(el => el.refresh())
        });
    });
}

/**
 * Slick or slide initialization
 */
whenAvailable('$', function() {
$(function(){
    whenAvailable('slick',function() {
         $('.slick-revolving').on('init', function(event, slick){
              whenAvailable('lazyload', function(){
                   setTimeout(function() {
                        initLazyload();
                   }, 500);
              });
         });
         function initSlickRevolving() {
              let slick_intialized = $('.slick-revolving').hasClass('slick-initialized');
              if ( !slick_intialized) {
                   $('.slick-revolving')?.slick({
                        mobileFirst: true,
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '8vw',
                        dots: true,
                        prevArrow: '<div class="arrow-prev d-md-flex"><svg class="d-none d-md-block ms-auto me-3 me-xl-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path d="M59.74 115.2a2.59 2.59 0 0 1-3.66 0L.76 59.8a2.58 2.58 0 0 1 0-3.65L56.08.76a2.58 2.58 0 0 1 3.66 3.65L6.24 58l53.5 53.56a2.59 2.59 0 0 1 0 3.66z"></path></svg></div>',
                        nextArrow: '<div class="arrow-next d-md-flex"><svg class="d-none d-md-block ms-3 ms-xl-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path d="M.76.76a2.58 2.58 0 0 1 3.65 0l55.33 55.4a2.58 2.58 0 0 1 0 3.65L4.4 115.2a2.58 2.58 0 1 1-3.65-3.65L54.26 58 .76 4.42a2.59 2.59 0 0 1 0-3.66z"></path></svg></div>',
                        responsive: [
                             {
                                  breakpoint: 767,
                                  settings: {
                                       centerMode: true,
                                       centerPadding: 'calc(100vw / 8)'
                                  }
                             },
                             {
                             breakpoint: 1500,
                             settings: {
                                       centerMode: true,
                                       centerPadding: 'calc(100vw / 7)'
                                  }
                             }
                        ]
                   });
                   /**
                    * Stack all images and show based on the current slide index
                    * Works for image background slider to transition or animate smoothly
                    */
                   $('.slick-revolving').on('afterChange', function(event, slick, currentSlide, nextSlide){
                        // slider images
                        $(`.image-slide`).removeClass("active")
                        $(`.image-slider-bg-${currentSlide}`).addClass("active")

                        //frame shadow highlight
                        $(`.card-border`).removeClass("active")
                        $(`.slider-${currentSlide} .card-border`).addClass("active")

                   });
              }
         }
         initSlickRevolving();
         window.onresize = () => { initSlickRevolving() }
    });
});
});
